import { FC } from 'react';
import type { Question as QuestionType } from '../Questionnaire';
import Question from './Question';

interface Props {
  questions: QuestionType[];
}

const Questions: FC<Props> = ({ questions }) => (
  <>
    {questions.map((question, index) => (
      <Question key={question.questionId} item={question} index={index} />
    ))}
  </>
);

export default Questions;
